export const crafts = [
  {
    id: 'craft-1',
    title: 'Rainbow Dream Catcher',
    difficulty: 'Easy',
    time: '30 mins',
    category: 'home-decor',
    description: 'Create a magical dream catcher to hang above your bed!',
    image: 'https://images.unsplash.com/photo-1533637610539-a5b57f6a6cab?w=400&h=300&fit=crop',
    materials: [
      'Paper plate',
      'Colorful yarn',
      'Feathers',
      'Beads',
      'Glue',
      'Scissors'
    ],
    steps: [
      'Cut out the center of a paper plate',
      'Wrap colorful yarn around the plate ring',
      'Create a web pattern with yarn inside',
      'Tie feathers and beads to strings',
      'Hang your dream catcher!',
      'Add glitter for extra sparkle ✨'
    ],
    secretCode: 'RAINBOW123',
    icon: '🌈'
  },
  {
    id: 'craft-2',
    title: 'Glitter Jar Magic',
    difficulty: 'Easy',
    time: '15 mins',
    category: 'calm-down',
    description: 'Make a calming glitter jar for relaxation!',
    image: 'https://images.unsplash.com/photo-1620503374956-c942862f0372?w=400&h=300&fit=crop',
    materials: [
      'Clear jar with lid',
      'Warm water',
      'Clear glue',
      'Glitter (multiple colors)',
      'Food coloring'
    ],
    steps: [
      'Fill jar 3/4 with warm water',
      'Add 2 tablespoons of clear glue',
      'Add glitter and food coloring',
      'Seal lid tightly',
      'Shake and watch the magic!',
      'Use when you need to relax 💫'
    ],
    secretCode: 'SPARKLE456',
    icon: '✨'
  },
  {
    id: 'craft-3',
    title: 'Unicorn Bookmarks',
    difficulty: 'Easy',
    time: '20 mins',
    category: 'reading',
    description: 'Corner bookmarks shaped like unicorns!',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=300&fit=crop',
    materials: [
      'Colored cardstock',
      'Glue stick',
      'Markers',
      'Googly eyes',
      'Glitter'
    ],
    steps: [
      'Cut a square piece of paper',
      'Fold into a triangle bookmark',
      'Cut and glue unicorn horn and ears',
      'Add googly eyes and draw face',
      'Decorate with glitter',
      'Use in your favorite books! 📚'
    ],
    secretCode: 'UNICORN789',
    icon: '🦄'
  },
  {
    id: 'craft-4',
    title: 'Friendship Bracelets',
    difficulty: 'Medium',
    time: '45 mins',
    category: 'jewelry',
    description: 'Weave colorful friendship bracelets!',
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=400&h=300&fit=crop',
    materials: [
      'Embroidery thread (3-4 colors)',
      'Tape or safety pin',
      'Scissors',
      'Beads (optional)'
    ],
    steps: [
      'Cut 3 strands of thread, each 24 inches',
      'Tie a knot at the top',
      'Secure with tape or pin',
      'Braid or weave patterns',
      'Add beads as you go',
      'Tie off and share with friends! 💕'
    ],
    secretCode: 'FRIENDS101',
    icon: '💝'
  },
  {
    id: 'craft-5',
    title: 'Paper Flower Garden',
    difficulty: 'Medium',
    time: '40 mins',
    category: 'flowers',
    description: 'Create a bouquet that never wilts!',
    image: 'https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=400&h=300&fit=crop',
    materials: [
      'Tissue paper (various colors)',
      'Green pipe cleaners',
      'Scissors',
      'Tape',
      'Vase or cup'
    ],
    steps: [
      'Stack 4-5 sheets of tissue paper',
      'Fold accordion-style',
      'Wrap pipe cleaner in the middle',
      'Carefully separate each layer',
      'Fluff petals to create flower',
      'Make a whole bouquet! 🌸'
    ],
    secretCode: 'GARDEN202',
    icon: '🌺'
  },
  {
    id: 'craft-6',
    title: 'Magic Wand',
    difficulty: 'Easy',
    time: '25 mins',
    category: 'pretend-play',
    description: 'Craft your own magical wand!',
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=400&h=300&fit=crop',
    materials: [
      'Wooden dowel or stick',
      'Ribbon',
      'Star cutout (cardboard)',
      'Paint',
      'Glitter glue',
      'Hot glue (with adult help)'
    ],
    steps: [
      'Paint your stick and star',
      'Glue star to top of stick',
      'Decorate with glitter glue',
      'Wrap ribbon around stick',
      'Add bells or beads',
      'Cast magical spells! ⭐'
    ],
    secretCode: 'MAGIC303',
    icon: '✨'
  },
  {
    id: 'craft-7',
    title: 'Painted Rock Pets',
    difficulty: 'Easy',
    time: '35 mins',
    category: 'nature',
    description: 'Turn rocks into adorable pet friends!',
    image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=400&h=300&fit=crop',
    materials: [
      'Smooth rocks',
      'Acrylic paint',
      'Paintbrushes',
      'Googly eyes',
      'Clear sealant spray'
    ],
    steps: [
      'Clean and dry rocks',
      'Paint base color',
      'Add faces and details',
      'Glue googly eyes',
      'Let dry completely',
      'Seal with spray (adult help) 🐢'
    ],
    secretCode: 'ROCKPET404',
    icon: '🪨'
  },
  {
    id: 'craft-8',
    title: 'Butterfly Sun Catchers',
    difficulty: 'Easy',
    time: '30 mins',
    category: 'window-art',
    description: 'Make beautiful window decorations!',
    image: 'https://images.unsplash.com/photo-1520990761679-48ff21fb1b02?w=400&h=300&fit=crop',
    materials: [
      'Black construction paper',
      'Tissue paper (various colors)',
      'Glue',
      'Scissors',
      'String'
    ],
    steps: [
      'Draw butterfly outline on black paper',
      'Cut out butterfly and wing centers',
      'Glue tissue paper behind openings',
      'Let dry completely',
      'Hang in sunny window',
      'Watch the colors glow! 🦋'
    ],
    secretCode: 'BUTTERFLY505',
    icon: '🦋'
  },
  {
    id: 'craft-9',
    title: 'Secret Message Decoder',
    difficulty: 'Medium',
    time: '40 mins',
    category: 'spy',
    description: 'Create a secret code wheel for spy messages!',
    image: 'https://images.unsplash.com/photo-1516410529446-2c777cb7366d?w=400&h=300&fit=crop',
    materials: [
      'Two paper plates',
      'Markers',
      'Brad fastener',
      'Ruler',
      'Scissors'
    ],
    steps: [
      'Write alphabet around edge of both plates',
      'Offset second plate by a few letters',
      'Poke hole in center of both',
      'Attach with brad fastener',
      'Rotate to encode messages',
      'Share the code with friends! 🔐'
    ],
    secretCode: 'DECODER606',
    icon: '🕵️'
  }
];

export const getCraftById = (id) => {
  return crafts.find(craft => craft.id === id);
};

export const getCraftsByCategory = (category) => {
  return crafts.filter(craft => craft.category === category);
};
